import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnetassessComponent } from './enetassess/enetassess.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { LoadexamComponent } from './loadexam/loadexam.component';
import { LoginComponent } from './login/login.component';
import { LoginDemoComponent } from './login/logindemo.component';
import { MediaComponent } from './media/media.component';
import { QuestionsComponent } from './questions/questions.component';
import { ResumeexamComponent } from './resumeexam/resumeexam.component';
import { QuestionPreviewComponent } from './questionpreview/questionpreview'


const routes: Routes = [
  { path: '', redirectTo: 'login.aspx', pathMatch: 'full' },
  { path: 'login', redirectTo: 'login.aspx', pathMatch: 'full' },
  { path: 'enetassess', component: EnetassessComponent },
  { path: 'feedback', component: FeedbackComponent },
  { path: 'loadexam', component: LoadexamComponent },
  { path: 'login.aspx', component: LoginComponent },
  { path: 'logindemo', component: LoginDemoComponent },
  { path: 'media', component: MediaComponent },
  { path: 'questions', component: QuestionsComponent },
  { path: 'resumeexam', component: ResumeexamComponent },
  { path: 'preview', component:QuestionPreviewComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
